module.exports = __webpack_public_path__ + "img/tree_q90_lossy.20919223.webp";